import { FC } from 'react';
import { Tabs as MuiTabs, TabsProps as MuiTabsProps, SxProps, Theme } from '@mui/material';

interface TabsProps extends MuiTabsProps { sx?: SxProps<Theme> }

const Tabs: FC<TabsProps> = ({ sx = [], ...props }) => (
  <MuiTabs
    sx={[
      (theme) => ({
        '& .MuiTab-root': {
          color: '#000',
          fontWeight: 700,
          fontStyle: 'Text - Medium'
        },
        '& .MuiTab-root.Mui-selected': {
          color: theme.colors.primary
        },
        '& .MuiTabs-indicator': {
          backgroundColor: theme.colors.primary
        }
      }),
      ...(Array.isArray(sx) ? sx : [sx])
    ]} {...props} />
);

export default Tabs;
